import React, { ChangeEvent, FC, MouseEvent } from 'react';
import { Checkbox } from '@mui/material';
import { Order } from 'models/order';

type OrderCheckBoxProps = {
    order: Order;
    onHandleCheckedOrders?: (order: Order, checked: boolean) => void;
    isAtLimit?: boolean;
    checked?: boolean;
};

const OrderCheckBox: FC<OrderCheckBoxProps> = ({
    order,
    onHandleCheckedOrders,
    isAtLimit,
    checked = false,
}: OrderCheckBoxProps) => {
    const handleEventBubbling = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
    };

    const handleCheckClick = (event: ChangeEvent<HTMLInputElement>) => {
        if (onHandleCheckedOrders) {
            onHandleCheckedOrders(order, event.target.checked);
        }
    };

    return (
        <div onClick={handleEventBubbling}>
            <Checkbox
                checked={checked}
                onChange={handleCheckClick}
                disabled={isAtLimit && !checked}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
            />
        </div>
    );
};

export default OrderCheckBox;
